import { withInstall } from '@zoryn/utils'
import Input from './src/input.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZInput: SFCWithInstall<typeof Input> = withInstall(Input)
export default ZInput

export * from './src/input'
export type { InputInstance } from './src/instance'
